import {getAccountDeletion} from '../models/AccountDeletion';

export interface SignedDownload { url: string; expiresAt: string; }
export interface SignedUpload extends SignedDownload { id: string; uploadToken: string; headers: Record<string, string>; }
const originalNames = new WeakMap<File, string>();
export const rememberOriginalName = (draft: File, original: File) => { originalNames.set(draft, original.name); return draft; };
export const fileMetadata = (file: File, maxLength = 52428800) => {
    const fileName = originalNames.get(file) ?? file.name;
    if (!['image/jpeg', 'image/png', 'image/webp'].includes(file.type) || file.size < 1 || file.size > maxLength || fileName.length > 255) throw new Error('JPEG, PNG, WebP: invalid file type, size or name');
    return {fileName, contentType: file.type, length: file.size};
};
export const putSignedImage = async (upload: SignedUpload, file: File) => {
    if (getAccountDeletion().isReadOnly) throw {status: 403, data: {code: 'account.read_only'}};
    const response = await fetch(upload.url, {method: 'PUT', headers: upload.headers, body: file, credentials: 'omit'});
    if (!response.ok && response.status !== 412) throw new Error('Image upload failed (' + response.status + ')');
};
